var _window$CONFIGS;
import { wujiRequest } from "../../core/common/wujiRequest";
import { keys, get, set, cloneDeep } from "lodash-es";
export var LogRequestStatus;
(function (LogRequestStatus) {
  LogRequestStatus[LogRequestStatus["SUCCESS"] = 0] = "SUCCESS";
  LogRequestStatus[LogRequestStatus["KEY_ENOENT"] = 1] = "KEY_ENOENT";
  LogRequestStatus[LogRequestStatus["REDIS_ENOENT"] = 2] = "REDIS_ENOENT";
  LogRequestStatus[LogRequestStatus["NOT_LOADED_YET"] = 4] = "NOT_LOADED_YET";
})(LogRequestStatus || (LogRequestStatus = {}));
export const NormalBaseLogicMap = {
  等于: '=',
  不等于: '!=',
  存在于集合: 'in',
  不存在于集合: 'not in'
};
export const NormalStringLogicMap = {
  ...NormalBaseLogicMap,
  开头类似于: 'like .%',
  类似于: 'like'
};
export const NormalIntLogicMap = {
  ...NormalBaseLogicMap,
  大于: '>',
  大于或等于: '>=',
  小于: '<',
  小于或等于: '<='
};
export const NormalLogicMap = {
  string: NormalStringLogicMap,
  int: NormalIntLogicMap
};
export const getData = async (param, projectId) => {
  const newWhere = cloneDeep(param.where) || [];
  if (!(newWhere !== null && newWhere !== void 0 && newWhere.some(cqlArray => ['project_id'].includes(cqlArray[0])))) {
    newWhere.push(['project_id', '=', projectId]);
  }
  const res = await wujiRequest({
    url: '/api/xy/log',
    params: {
      projectid: projectId,
      data: JSON.stringify({
        logid: get(window, 'GLOBAL_INFO.deploySettingFlag.logId', 104114),
        // 默认返回100条
        limit: 100,
        // 默认全部字段
        fields: keys(fieldsMap),
        // 默认时间倒序
        sortKey: ['ftime'],
        sortDir: 'DESC',
        ...param,
        where: newWhere
      })
    }
  });
  if (res.code !== 0) {
    throw new Error(`获取日志数据失败, code: ${res.code}`);
  }
  return res;
};
export const searchClsLogger = async (projectId, cql, param) => {
  var _param$where;
  const timeConditionArr = (_param$where = param.where) === null || _param$where === void 0 ? void 0 : _param$where.find(i => i[0] === 'ftime' && i[1] === 'between');
  const from = +new Date((timeConditionArr === null || timeConditionArr === void 0 ? void 0 : timeConditionArr[2]) || 0);
  const to = +new Date((timeConditionArr === null || timeConditionArr === void 0 ? void 0 : timeConditionArr[3]) || 0);
  const res = await wujiRequest({
    url: '/api/xy/log/search/cls',
    params: {
      projectid: projectId
    },
    headers: {
      'content-type': 'application/json'
    },
    method: 'post',
    data: JSON.stringify({
      // 默认返回100条
      limit: +(param.limit || 0) || 100,
      from,
      to,
      query: cql || ''
    })
  });
  if (res.code !== 0) {
    throw new Error(res.error);
  }
  return res;
};
export const LogLevelMap = {
  1: '普通(Log)',
  2: '通知(Info)',
  3: '告警(Warn)',
  4: '错误(Error)'
};
export const LogInfoFields = [{
  id: 'extinfo',
  title: '上报服务器'
}, {
  id: 'seq',
  title: '序列号'
}, {
  id: 'rtx',
  title: '操作人'
}, {
  id: 'host',
  title: '主机头'
}, {
  id: 'dimen',
  title: '维度描述'
}, {
  id: 'seq_index',
  title: '周期内时序'
}, {
  id: 'path',
  title: '请求路径'
}, {
  id: 'seq_time',
  title: '周期内耗时'
}, {
  id: 'referer',
  title: '请求来源',
  span: 2
}, {
  id: 'msg',
  title: '日志内容',
  span: 2
}];
export const fieldsMap = {
  ftime: '上报日期',
  extinfo: '上报服务器',
  rtx: '操作人',
  seq: '序列号',
  msg: '日志内容',
  level: '等级',
  dimen1: '维度1',
  dimen2: '维度2',
  dimen3: '维度3',
  dimen4: '维度4',
  dimen5: '维度5',
  host: '主机头',
  project_id: '项目id',
  seq_index: '周期内时序',
  path: '请求路径',
  seq_time: '周期内耗时',
  referer: 'referer',
  cookie: 'cookie'
};
// @ts-ignore
if ((_window$CONFIGS = window.CONFIGS) !== null && _window$CONFIGS !== void 0 && _window$CONFIGS.useWujiMock) {
  set(fieldsMap, 'mockedBy', '模拟登录人');
}
//# sourceMappingURL=common.js.map
